import { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getPrescriptionByReferenceCode } from "../../../api/prescriptionService";
import PrescriptionSymbol from "./PrescriptionSymbol";

const PrescriptionDisplay = ({code}) => {
  const { t } = useTranslation("common");
  const [data, setData] = useState(null);
  const [message, setMessage] = useState(t('appointments.public.messages.wait'));

  const baseApiUrl = process.env.REACT_APP_API_URL;
  const publicUploadsFolder = "public_uploads";
  const [logoImgSrc, setLogoImgSrc] = useState("");
  const [signImgSrc, setSignImgSrc] = useState("");

  const fetchData = async () => {
    try {
      const data = await getPrescriptionByReferenceCode(code);
      setData(data);
      const bustCache = Date.now(); // unique value each time
      setLogoImgSrc(`${baseApiUrl}/${publicUploadsFolder}/logo-${data.office.id}.png?${bustCache}`);
      setSignImgSrc(`${baseApiUrl}/${publicUploadsFolder}/sign-${data.user.id}.png?${bustCache}`);
    } catch(error) {
      setMessage("Prescription not found");
    }
    
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {!data ? 
      <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "1rem" }}>
          {message} 
      </Typography>
      :
      <>
        <div id="print-section">
        <Box
          component="img"
          src={logoImgSrc}
          alt="logo"
          sx={{
              maxHeight: 120,
              display: "block",    // removes inline spacing
              margin: "0 auto"     // optional: center horizontally
          }}
          onError={(e) => {
            e.currentTarget.src = "/images/logo-0.png";
          }}
        />
        <Typography textAlign='center' variant="body2" sx={{ mt: 0 }}>{data.office.name}</Typography>
        <Typography textAlign='center' variant="body2" sx={{ mt: 0 }}>{data.office.address}</Typography>
        <Typography textAlign='center' variant="body2" sx={{ mt: 0 }}>{`tel. no. ${data.office.contact_number} e-mail ${data.office.email}`}</Typography>
        <br />
        <Box>
          <PrescriptionSymbol size={70} />
          <br />
          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Reference Code</Typography>
          <Typography variant="body1" sx={{ mt: 0 }}>{data.reference_code}</Typography>

          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Date</Typography>
          <Typography variant="body1" sx={{ mt: 0 }}>{data.date}</Typography>

          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Valid Until</Typography>
          <Typography variant="body1" sx={{ mt: 0 }}>{data.validity_date || "(not specified)"}</Typography>

          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Patient</Typography>
          <Typography variant="body1" sx={{ mt: 0 }}>{`${data.petOwner.first_name} ${data.petOwner.last_name} for pet ${data.pet.name}`}</Typography>

          <br />
          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Prescription Details:</Typography>
          <br />
          <Typography variant="body1" sx={{ mt: 0, whiteSpace: 'pre-line' }}>{data.content}</Typography>

          <br />
          <br />
          <Box
            component="img"
            src={signImgSrc}
            alt="sign"
            sx={{
                maxWidth: 200,       // but never exceeds 500px
                display: "block",    // removes inline spacing
                marginLeft: 0 
            }}
            onError={(e) => {
              e.currentTarget.src = "/images/sign-0.png";
            }}
          />
          <Typography variant="body1" sx={{ mt: 0 }}>{data.user.professional_name}</Typography>
          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>License No.</Typography>
          <Typography variant="body1" sx={{ mt: 0 }}>{data.user.license_number}</Typography>
          <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>PTR No.</Typography>
          <Typography variant="body1" sx={{ mt: 0 }}>{data.user.ptr_number}</Typography>
        </Box>
        </div>
      </>
      }
    </>
  );
};

export default PrescriptionDisplay;